/* eslint-disable react/no-array-index-key */
import React, { memo } from "react";
import PropTypes from "prop-types";
import { boolean } from "yup";

const LogoMarquee = ({
  data,
  itemClassName,
  duration,
  customCss = "",
  customHeight = "",
  fullWidth = false,
}) => {
  return (
    <div
      className={`flex whitespace-no-wrap overflow-x-hidden ${customHeight}`}>
      <div className={`relative flex ${customCss}`}>
        <ul
          className={`flex flex-nowrap ${
            fullWidth ? "animate-marquee" : "animate-marquee min-w-full"
          } `}
          style={{ animationDuration: duration }}>
          {data?.concat(data).map((d, index) => (
            <li className={itemClassName} key={`${d.id}-${index}`}>
              <img
                className={`w-full block flex-shrink-0 ${d.className ?? ""}`}
                src={d.src}
                alt={d.alt}
                width={d.width}
                height={d.height}
                loading="lazy"
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
LogoMarquee.defaultProps = {
  data: [],
  duration: "30s",
  itemClassName:
    "flex-shrink-0 flex items-center align-center h-[50px] mx-[26px] md:mx-[40px]",
  customCss: "",
  customHeight: "",
  fullWidth: boolean,
};
LogoMarquee.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      src: PropTypes.string,
      alt: PropTypes.string,
      width: PropTypes.string,
      height: PropTypes.string,
      className: PropTypes.string,
    }),
  ),
  itemClassName: PropTypes.string,
  duration: PropTypes.string,
  customCss: PropTypes.string,
  customHeight: PropTypes.string,
  fullWidth: PropTypes.bool,
};
export default memo(LogoMarquee);
